import DotLabel from "@shared/ui/dot-label/dot-label";
import "./paid-tag.scss";

export interface PaidTagProps {
  isPaid: boolean;
}

export function PaidTag({ isPaid }: PaidTagProps) {
  return (
    <div id="PaidTag" className="paid-tag">
      <DotLabel
        label={isPaid ? "Paid" : "Unpaid"}
        classBg={isPaid ? "bg-green-500" : "bg-red-500"}
      />
    </div>
  );
}

export default PaidTag;
